<template>
    <svg id="Lager_1" data-name="Lager 1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 11.6999998 11.6999998">
        <defs>
        </defs>
        <rect class="cls-1" x=".1466928" y="3.1222765" width="11.4066142" height="2.2806703"/>
        <rect class="cls-1" x=".9278183" y="5.4029468" width="9.8671006" height="6.1508345"/>
        <g>
            <path class="cls-1" d="M5.8499999,3.1222765S6.010124.1462185,8.0395617.1462185c1.9707079,0,.9266243,2.9760581-2.1895618,2.9760581"/>
            <path class="cls-1" d="M5.8499999,3.1222765S5.6898758.1462185,3.6604382.1462185c-1.9707079,0-.9266243,2.9760581,2.1895618,2.9760581"/>
        </g>
        <line class="cls-1" x1="5.8499999" y1="11.5537813" x2="5.8499999" y2="3.1222765"/>
        <line class="cls-1" x1="5.8499999" y1="3.1222765" x2="7.3386603" y2="4.610937"/>
        <line class="cls-1" x1="5.8499999" y1="3.1222765" x2="4.3613395" y2="4.610937"/>
    </svg>
</template>
<style scoped>
.cls-1 {
    fill: none;
    stroke: #000;
    stroke-linejoin: round;
    stroke-width: 0.25px;
}
</style>
